'use client'

import { ProgressBarProvider } from 'react-transition-progress'

import type { ChildrenProps } from '../types'

import RouteProgressBar from '../components/RouteProgressBar'

type Props = { className?: string; withProgressBar?: boolean } & ChildrenProps
export default function NavigationProgressProvider({
  children,
  className,
  withProgressBar = true,
}: Props) {
  return (
    <ProgressBarProvider>
      {withProgressBar && <RouteProgressBar className={className} />}
      {children}
    </ProgressBarProvider>
  )
}
